import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\IndexScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/IndexScheduledTaskController.php
* @route '/api/scheduled-task'
*/
const IndexScheduledTaskController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: IndexScheduledTaskController.url(options),
    method: 'get',
})

IndexScheduledTaskController.definition = {
    methods: ["get","head"],
    url: '/api/scheduled-task',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ScheduledTask\IndexScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/IndexScheduledTaskController.php
* @route '/api/scheduled-task'
*/
IndexScheduledTaskController.url = (options?: RouteQueryOptions) => {
    return IndexScheduledTaskController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\IndexScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/IndexScheduledTaskController.php
* @route '/api/scheduled-task'
*/
IndexScheduledTaskController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: IndexScheduledTaskController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ScheduledTask\IndexScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/IndexScheduledTaskController.php
* @route '/api/scheduled-task'
*/
IndexScheduledTaskController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: IndexScheduledTaskController.url(options),
    method: 'head',
})

export default IndexScheduledTaskController